import React from 'react';
import Img from "../../images/services/ac/custom.png";
import {Container, Row, Col} from "react-bootstrap";
import {LazyLoadImage} from "react-lazy-load-image-component";

function Buildpurpose(props) {
    return (
        <div className="services_orange_bg p-100">
            <Container>
                <Row>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto text-center order-2 order-md-1">
                        <LazyLoadImage
                            src={Img}
                            effect="blur" alt="Image" className="img-fluid"
                        />
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="services_title my-auto order-1 order-md-2">
                        <h2> Go Beyond Efficiency</h2>
                        <p>TekRevol’s digital automation services go beyond efficiency. Here, we are working on
                            self-evolving deep-learning systems that open new ways to innovate business processes.
                            That’s why we don’t only create and implement automatic systems; we scale our automation
                            efforts.</p>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Buildpurpose;